module.exports = __webpack_public_path__ + "media/images/badge-draft-active-e4ebd4ce4b4eee0688e3be398bc2896f.svg";